import BaseComponent from "@/asdcom/BaseComponent";
import { IVcClaimDto, VcClaimDto } from "@/asdcom/apiproxy/apiproxy.dto";


export default class ClaimViewBaseComponent extends BaseComponent {

    public claimNumber?: string;

    public async getCurrentClaim(): Promise<VcClaimDto> {
        this.claimNumber = this.$route.params["claimNumber"];
        abp.log.debug({ "ClaimViewBaseComponent claimnumber": this.claimNumber });
        return this.$appsvs.vcpOnlineOkStaff.retrieveVcClaimForStaff(this.claimNumber);
    }

    public get vcClaimNumber(): string {
        this.claimNumber = this.$route.params["claimNumber"];
        return this.claimNumber;
    }

    
}